/*
    * Type Scripts Methods And Events
*/
import Vue from "vue";
import Axios from 'axios';
import moment from 'moment';
import * as _ from 'lodash';
import { Announcement } from "../../../../store/modules/App/Assets/Announcement/types";
import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { http } from '@/shared/https';
const namespace: string = "RootAnnouncement";

/*
    * Component's properties and events
*/
@Component({
    components: {
    }
})

export default class AnnouncementComponent extends Vue {
    @State("RootAnnouncement") announcement!: Announcement;

    /*
        * The mounted() method gives you access to templates and enables interaction with the DOM.
    */
    mounted() {
        let context = this.announcement;

        //#.Get announcement list
        return http.get('/api/Dashboard/GetAnnouncement').then(record => {
            if (record.data.Result == 'OK') {

                _.forOwn(record.data.record, function (key, val) {
                    if (key.FromDate) {
                        key.FromDate = moment(key.FromDate).format('ll');
                    }
                });

                context.items = record.data.record;
            }
        });
    }

    /*
        * Reset announcement read and unread props
    */
    _annRead(id, read) {
        let context = this.announcement, root = this.$store.state.RootApp;
        let announcement = root.buttons.btn.find(x => x.name == 'announce');

        //#.Set announcement count
        if (announcement) {
            if (read == 1)
                announcement.count = announcement.count + 1;
            else if (announcement.count != 0)
                announcement.count = announcement.count - 1;
        }

        //#.Reset announcement read and unread props
        context.items.filter(x => x.AnnouncementUserWiseId == id).find(x => x).ReadUnRead = (read == 0 ? 1 : 0);

        //#.Get announcement list
        return http.get('/api/Dashboard/GetRead/' + id + '/' + read).then(record => {
            if (record.data.Result == 'OK') {
            }
        });
    }

    /*
        * Delete existing announcements
    */
    _annDelete(id) {
        let context = this.announcement, items = [];
        //#.Reset announcement read and unread props
        let announcement = context.items.filter(x => x.AnnouncementUserWiseId == id).find(x => x);
        let index = context.items.indexOf(announcement);

        if (index != -1) {
            _.forOwn(context.items, function (key, val) {
                if (key.AnnouncementUserWiseId != announcement.AnnouncementUserWiseId) {
                    // @ts-ignore
                    items.push(key);
                }
            });

            // @ts-ignore
            context.items = items;
            
            //#.Remove component in the DOM.
            context.enabled = false;

            Vue.nextTick(() => {
                //#.Add the component back in
                context.enabled = true;
            });
        }

        //#.Delete existing announcements
        return http.delete('/api/Dashboard/GetDelete/' + id).then(record => {
            if (record.data.Result == 'OK') {
                context.snackbar = true;
            }
        });
    }
}